import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "changeDescription.title",
    },
    label: {
        id: "newTest.label",
    },
    description: {
        id: "newTest.description",
    },
    rename: {
        id: "changeDescription.submit",
    },
    cancel: {
        id: "general.cancel",
    },
});

export default messages;
